import React, { Component } from "react";
import savvyLogo1 from "../assets/img/savvycommunity-logo.jpeg";
import savvyLogo from "../assets/img/savvy-logo.png";
import savvyLogoTransparent from "../assets/img/savvy-transparent-logo.png";
import { brandName } from "../shared/setting";
import "./OrciBanner.css";

class OrciBanner extends Component {
  render() {
    return (
      <div className="account-logo">
        <div className="logo-avatar">
          <img
            src={savvyLogoTransparent}
            alt={`${brandName} logo`}
            className="logo-image"
          />
        </div>
        {/* <h4>{brandName}</h4> */}
      </div>
    );
  }
}

export default OrciBanner;
